import React from 'react'
import { Modal, Box } from '@mui/material';
import ChooseFields from './ChooseFields';
import ChooseWeek from './ChooseWeek';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: '0 5px 16px rgba(0, 0, 0, 0.2)',
    p: 4,
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: '80vh',
    outline: 'none'
};


const ModalBox = ({open, handleClose, modalField}) => {
  return (
    
    <Box>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                {modalField === "items" && <ChooseFields />}
                {modalField === "weeks" && <ChooseWeek />}
                {/* <ChooseFields /> */}
            </Box>
        </Modal>
    </Box>
  )
}

export default ModalBox